"use strict";

import Modal from 'bootstrap/js/dist/modal';

export function init () {

    let availabilityModalBody = document.getElementById('js-availability-modal-content');
    if(availabilityModalBody) {
        let availabilityModalEl = document.getElementById('js-availability-modal');
        let availabilityModal = Modal.getInstance(availabilityModalEl);
        availabilityModal.show();
    }
}
